export const Delete = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			d="M6.5 6.5C6.91421 6.5 7.25 6.83579 7.25 7.25V11.75C7.25 12.1642 6.91421 12.5 6.5 12.5C6.08579 12.5 5.75 12.1642 5.75 11.75V7.25C5.75 6.83579 6.08579 6.5 6.5 6.5Z"
			fill="currentColor"
		/>
		<path
			d="M10.25 7.25C10.25 6.83579 9.91421 6.5 9.5 6.5C9.08579 6.5 8.75 6.83579 8.75 7.25V11.75C8.75 12.1642 9.08579 12.5 9.5 12.5C9.91421 12.5 10.25 12.1642 10.25 11.75V7.25Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 3.5V2C5 1.17157 5.67157 0.5 6.5 0.5H9.5C10.3284 0.5 11 1.17157 11 2V3.5H14.75C15.1642 3.5 15.5 3.83579 15.5 4.25C15.5 4.66421 15.1642 5 14.75 5H13.9062L13.3819 13.3904C13.3077 14.5762 12.3244 15.5 11.1362 15.5H4.86377C3.67562 15.5 2.69226 14.5762 2.61815 13.3904L2.09375 5H1.25C0.835786 5 0.5 4.66421 0.5 4.25C0.5 3.83579 0.835786 3.5 1.25 3.5H5ZM6.5 2H9.5V3.5H6.5V2ZM3.59668 5L4.11523 13.2968C4.13993 13.6921 4.46772 14 4.86377 14H11.1362C11.5323 14 11.8601 13.6921 11.8848 13.2968L12.4033 5H3.59668Z"
			fill="currentColor"
		/>
	</svg>
);
